import { NoneOrderTagDetailResponse } from "apis/data-contracts";
import { useEffect, useMemo, useState } from "react";
import { useRecoilValue } from "recoil";
import {
  selectedAnalysisBusinessTagState,
  selectedAnalysisCityState,
  selectedAnalysisProvinceState,
} from "store/document/analysisDocument";

const useAnalysisDocumentTags = () => {
  const province = useRecoilValue(selectedAnalysisProvinceState);
  const city = useRecoilValue(selectedAnalysisCityState);
  const businessTag = useRecoilValue(selectedAnalysisBusinessTagState);

  const [businessTags, setBusinessTags] = useState<
    NoneOrderTagDetailResponse[]
  >([]);

  const regionTags = useMemo(
    () => (province ? (city ? [`${province} ${city}`] : [province]) : []),
    [province, city],
  );

  function getTagUuids() {
    const tagUuids = businessTags.map((tag) => tag.tagUuid) || [];

    return tagUuids;
  }
  useEffect(() => {
    if (!businessTag) return;

    setBusinessTags([businessTag]);
  }, [businessTag]);

  return {
    selectedProvince: province,
    selectedCity: city,

    regionTags,
    businessTags,

    getTagUuids,
  };
};

export default useAnalysisDocumentTags;
